export async function downloadImage(url) {
  try {
    const response = await fetch(url);
    const contentType = response.headers.get('Content-Type');
    if (!response.ok || !contentType.startsWith('image/')) {
      return;
    }
    const arrayBuffer = await response.arrayBuffer();
    return arrayBuffer;
  } catch (e) {
    console.error(e);
    return;
  }
}

export const scaleImageDimensions = (img, maxDimension) => {
  const width = img.width;
  const height = img.height;
  const scale = Math.min(maxDimension / width, maxDimension / height, 1);
  return {
    width: width * scale,
    height: height * scale,
  };
};

export async function loadImage(uri, maxDimension = 150) {
  try {
    const response = await fetch(uri);
    if (!response.ok) {
      throw new Error('Failed to fetch image');
    }
    const blob = await response.blob();
    const arrayBuffer = await blob.arrayBuffer();
    const img = new Image();
    img.src = URL.createObjectURL(blob);

    await new Promise((resolve, reject) => {
      img.onload = resolve;
      img.onerror = reject;
    });

    const { width, height } = scaleImageDimensions(img, maxDimension);

    return { imageBuffer: arrayBuffer, width, height };
  } catch (error) {
    console.error('Error loading image:', error);
    return { imageBuffer: null, width: 0, height: 0 };
  }
}
